import { render, staticRenderFns } from "./base-layout.vue?vue&type=template&id=67f7264c&scoped=true"
import script from "./base-layout.vue?vue&type=script&lang=ts"
export * from "./base-layout.vue?vue&type=script&lang=ts"
import style0 from "./base-layout.vue?vue&type=style&index=0&id=67f7264c&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "67f7264c",
  null
  
)

export default component.exports